import React from 'react';

const workshops = [
  {
    title: 'Εργαστήριο Θεατρικής Κίνησης',
    dates: 'Ιανουάριος – Μάρτιος 2025',
    duration: '10 εβδομάδες',
    capacity: '12 άτομα',
    level: 'Αρχάριοι / Μεσαίοι',
    description: 'Ένα εργαστήριο αφιερωμένο στη σχέση σώματος και θεατρικής έκφρασης. Εξερευνούμε την κίνηση ως γλώσσα και ως αφηγηματικό εργαλείο.',
    image: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?w=600&q=80',
  },
  {
    title: 'Εργαστήριο Φωνής & Λόγου',
    dates: 'Απρίλιος – Ιούνιος 2025',
    duration: '8 εβδομάδες',
    capacity: '10 άτομα',
    level: 'Όλα τα επίπεδα',
    description: 'Αναζητούμε τη φωνή ως εκφραστικό μέσο, πέρα από την καθημερινή χρήση. Τεχνικές αναπνοής, χροιά, ρυθμός και σιωπή.',
    image: 'https://images.unsplash.com/photo-1516280440614-37939bbacd81?w=600&q=80',
  },
  {
    title: 'Εντατικό Θερινό Εργαστήριο',
    dates: 'Ιούλιος 2025',
    duration: '5 ημέρες',
    capacity: '20 άτομα',
    level: 'Προχωρημένοι',
    description: 'Πεντάμερο εντατικό πρόγραμμα για καλλιτέχνες. Συνδυάζει σκηνοθεσία, υποκριτική, χορογραφία και αυτοσχεδιασμό.',
    image: 'https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=600&q=80',
  },
];

export default function Workshops() {
  return (
    <section style={{ padding: '120px 64px', maxWidth: '1200px', margin: '0 auto' }}>
      <PageHeader title="Εργαστήρια" subtitle="Εκπαίδευση & Δημιουργία" />

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
        gap: '2px',
      }}>
        {workshops.map((w, i) => (
          <WorkshopCard key={i} workshop={w} />
        ))}
      </div>
    </section>
  );
}

function WorkshopCard({ workshop }) {
  const [hovered, setHovered] = React.useState(false);

  return (
    <div
      style={{
        background: hovered ? 'var(--black)' : 'var(--off-white)',
        transition: 'background 0.4s ease',
        cursor: 'pointer',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={{ overflow: 'hidden', aspectRatio: '16/9' }}>
        <img
          src={workshop.image}
          alt={workshop.title}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: hovered ? 'brightness(0.4) grayscale(100%)' : 'brightness(0.9)',
            transform: hovered ? 'scale(1.05)' : 'scale(1)',
            transition: 'all 0.5s ease',
          }}
        />
      </div>

      <div style={{ padding: '32px' }}>
        <h3 style={{
          fontFamily: 'var(--font-display)',
          fontSize: '1.5rem',
          fontWeight: 400,
          letterSpacing: '0.03em',
          color: hovered ? 'var(--white)' : 'var(--black)',
          marginBottom: '16px',
          transition: 'color 0.3s',
        }}>{workshop.title}</h3>

        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '10px',
          marginBottom: '20px',
        }}>
          {[
            { label: 'Ημερομηνίες', val: workshop.dates },
            { label: 'Διάρκεια', val: workshop.duration },
            { label: 'Συμμετέχοντες', val: workshop.capacity },
            { label: 'Επίπεδο', val: workshop.level },
          ].map(item => (
            <div key={item.label}>
              <p style={{
                fontSize: '0.58rem',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'var(--accent)',
                marginBottom: '3px',
              }}>{item.label}</p>
              <p style={{
                fontSize: '0.75rem',
                color: hovered ? 'var(--light-gray)' : 'var(--dark-gray)',
                fontWeight: 300,
                transition: 'color 0.3s',
              }}>{item.val}</p>
            </div>
          ))}
        </div>

        <p style={{
          fontSize: '0.8rem',
          lineHeight: 1.85,
          color: hovered ? 'var(--mid-gray)' : 'var(--dark-gray)',
          fontWeight: 300,
          letterSpacing: '0.02em',
          marginBottom: '24px',
          transition: 'color 0.3s',
        }}>{workshop.description}</p>

        <button style={{
          fontSize: '0.62rem',
          letterSpacing: '0.16em',
          textTransform: 'uppercase',
          color: hovered ? 'var(--accent)' : 'var(--black)',
          background: 'none',
          border: `1px solid ${hovered ? 'var(--accent)' : 'var(--black)'}`,
          padding: '10px 20px',
          cursor: 'pointer',
          fontFamily: 'var(--font-body)',
          transition: 'all 0.3s',
        }}>
          Περισσότερες Πληροφορίες
        </button>
      </div>
    </div>
  );
}

function PageHeader({ title, subtitle }) {
  return (
    <div style={{ marginBottom: '72px' }}>
      <p style={{
        fontSize: '0.62rem',
        letterSpacing: '0.2em',
        textTransform: 'uppercase',
        color: 'var(--accent)',
        marginBottom: '12px',
      }}>{subtitle}</p>
      <h1 style={{
        fontFamily: 'var(--font-display)',
        fontSize: 'clamp(2.5rem, 6vw, 5rem)',
        fontWeight: 300,
        letterSpacing: '0.04em',
        color: 'var(--black)',
        lineHeight: 1,
      }}>{title}</h1>
      <div style={{ width: '40px', height: '1px', background: 'var(--accent)', marginTop: '20px' }} />
    </div>
  );
}
